import { VueRenderer } from '@tiptap/vue-2'
import tippy from 'tippy.js'
import MentionList from '@/components/TipTap/MentionList'
import { debounce } from '@/assets/js/httpImports.js'
import { useMessagingStore } from '@/stores/messagingStore'

export default {
    items: debounce(async ({ query }) => {
        return useMessagingStore().getSuggestionList(query)
    }, 1500),

    render: () => {
        let component
        let popup
    
        return {
            onStart: async props => {
                if(props.items == undefined)
                {
                    props.items = await useMessagingStore().getSuggestionList(props.query)
                }
                component = new VueRenderer(MentionList, {
                // using vue 2:
                    parent: this,
                    propsData: props,
                    editor: props.editor,
                })

        
                if (!props.clientRect) {
                    return
                }
        
                popup = tippy('body', {
                    getReferenceClientRect: props.clientRect,
                    appendTo: () => document.body,
                    content: component.element,
                    showOnCreate: true,
                    interactive: true,
                    trigger: 'manual',
                    placement: 'bottom-start',
                })
            },
        
            onUpdate: debounce(async props => {
                if(props.items != undefined && !props.items.includes(props.query))
                {
                    props.items = await useMessagingStore().getSuggestionList(props.query)
                component.updateProps(props)
                }
        
                if (!props.clientRect) {
                  return
                }
        
                popup[0].setProps({
                    getReferenceClientRect: props.clientRect,
                })
            }, 2000),
        
            onKeyDown(props) {
                if (props.event.key === 'Escape') {
                    popup[0].hide()
            
                    return true
                }
                return component.ref?.onKeyDown(props)
            },
        
            onExit() {
                popup[0].destroy()
                component.destroy()
            },
        }
    }
}